import { Component, Input } from '@angular/core';

const DEFAULT_ICON_SIZE = 24;

@Component({
  selector: 'app-page-icon',
  standalone: true,
  templateUrl: './page-icon.component.html'
})
export class PageIconComponent {
  @Input() size?: number = DEFAULT_ICON_SIZE;
  @Input() width?: number;
  @Input() height?: number;
}
